import { ActionTree } from 'vuex';
import { State } from './log.store';
import { Context, Params } from '@/utils/types/global';
import { LOGService } from '@/services/api/log.service';
import getEnv from '@/utils/env';
import fragmentAll from '@/store/modules/log/logCommonState/log.metrics.types';
import axiosInstance from '@/services/api/http.service';
import { AxiosResponse } from 'axios';
import { STATUS_LABEL } from '@/components/Log/log.constants';
const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';

const actions: ActionTree<State, any> = {
  getLogGraphData(context: Context, params: Params) {
    const config =
      context.rootState.globalState.app.chartsTemplate.application[
        params.layoutIndex
      ][params.index];

    return LOGService.getGraphData({
      service_id: params.serviceId,
      duration: params.duration,
      metric_name: config.metricName
    }).then(res => {
      const resData = res.data.data;
      const graphData = {
        [config['queryMetricType']]: {
          values: {
            values: resData.values
          }
        }
      };
      return new Array({
        ...graphData,
        config
      });
    });
  },
  getLogDashboardWidgetData(context: Context, params: any) {
    let config = params.chartConfig || params.config;
    let variable;

    if (
      config.queryMetricType === 'readMetricsValues' ||
      config.queryMetricType === 'readMetricsValue'
    ) {
      variable = {
        duration: params.duration,
        condition: {
          name: config.metricName,
          entity: {
            scope: config.entityType,
            serviceName: config.serviceKey,
            normal: true
          },
          isLatestValue: config.isLatestValue,
          sort: config.sort
        }
      };
    }

    const fragments =
      config.chartType === STATUS_LABEL
        ? fragmentAll.getStatusLabelFragmentValue(config.aggregatorType)
        : fragmentAll[config.queryMetricType].fragment;
    const queryVariables = fragmentAll[config.queryMetricType].variable;
    const query = `query queryData(${queryVariables}) {${fragments}}`;
    return new axiosInstance({ auth: true })
      .post(
        OAP_HOST + '/graphql',
        { query, variables: variable },
        {
          // cancelToken: cancelToken()
        }
      )
      .then((res: AxiosResponse<any>) => {
        const resData = res.data.data;
        return [
          {
            ...resData,
            config,
            metricName: variable.condition.name
          }
        ];
      });
  }
};

export default actions;
